module.exports = __webpack_public_path__ + "static/timpview_labs-891e8c7b6bf359c122fcfb646ebc9b55.jpg";